import { render, staticRenderFns } from "./NoDealsStub.vue?vue&type=template&id=7e71db1c&lang=pug&"
import script from "./NoDealsStub.vue?vue&type=script&lang=ts&"
export * from "./NoDealsStub.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports